import { render, staticRenderFns } from "./centerDialog.vue?vue&type=template&id=1fb2875c&scoped=true&"
import script from "./centerDialog.vue?vue&type=script&lang=js&"
export * from "./centerDialog.vue?vue&type=script&lang=js&"
import style0 from "./centerDialog.vue?vue&type=style&index=0&id=1fb2875c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb2875c",
  null
  
)

export default component.exports